module.exports = __webpack_public_path__ + "img/JH.30ac8789.svg";